<div class="challenge-tutorial">
  <!-- Icon to close dialog -->

  <img src="assets/icons/general/close.svg" class="challenge-tutorial__close" (click)="closeModal()" />

  <h2 class="challenge-tutorial__heading">{{ 'CHALLENGE_TUTORIAL.heading' | translate }}</h2>

  <app-challenge-expansion-panel class="challenge-tutorial__container" trigger="all">
    <div expansionHeader class="challenge-tutorial__container-heading">
      {{ 'CHALLENGE_TUTORIAL.sectionTeamChallenge.heading' | translate }}
    </div>

    <div class="challenge-tutorial__container-section">
      {{ 'CHALLENGE_TUTORIAL.sectionTeamChallenge.point1' | translate: { weeks: challengeDurationInWeeks + 1 } }}
    </div>
    <div class="challenge-tutorial__container-section">
      {{ 'CHALLENGE_TUTORIAL.sectionTeamChallenge.point2' | translate }}
    </div>
    <div class="challenge-tutorial__container-section">
      {{ 'CHALLENGE_TUTORIAL.sectionTeamChallenge.point3' | translate }}
    </div>
    <div class="challenge-tutorial__container-section">
      {{ 'CHALLENGE_TUTORIAL.sectionTeamChallenge.point4' | translate }}
    </div>
  </app-challenge-expansion-panel>

  <app-challenge-expansion-panel class="challenge-tutorial__container" trigger="all">
    <div expansionHeader class="challenge-tutorial__container-heading">
      {{ 'CHALLENGE_TUTORIAL.sectionTeam.heading' | translate }}
    </div>

    <div class="challenge-tutorial__container-section">
      {{
        'CHALLENGE_TUTORIAL.sectionTeam.point1'
          | translate: { minTeamMembers: challenge?.minimalTeamMembers, maxTeamMembers: challenge?.maximumTeamMembers }
      }}
    </div>
    <div class="challenge-tutorial__container-section">
      {{ 'CHALLENGE_TUTORIAL.sectionTeam.point2' | translate: { minTeamMembers: challenge?.minimalTeamMembers } }}
    </div>
    <div class="challenge-tutorial__container-section">{{ 'CHALLENGE_TUTORIAL.sectionTeam.point3' | translate }}</div>
    <div class="challenge-tutorial__container-section">{{ 'CHALLENGE_TUTORIAL.sectionTeam.point4' | translate }}</div>
  </app-challenge-expansion-panel>

  <app-challenge-expansion-panel class="challenge-tutorial__container" trigger="all">
    <div expansionHeader class="challenge-tutorial__container-heading">
      {{ 'CHALLENGE_TUTORIAL.sectionPoints.heading' | translate }}
    </div>

    <div class="challenge-tutorial__container-section">{{ 'CHALLENGE_TUTORIAL.sectionPoints.point1' | translate }}</div>

    <div class="challenge-tutorial__container-section">
      <p>{{ 'CHALLENGE_TUTORIAL.sectionPoints.point2' | translate }}</p>
      <p>{{ 'CHALLENGE_TUTORIAL.sectionPoints.point3' | translate }}</p>
      <p>{{ 'CHALLENGE_TUTORIAL.sectionPoints.point4' | translate }}</p>
    </div>

    <div class="challenge-tutorial__container-section">
      <span [innerHTML]="'CHALLENGE_TUTORIAL.sectionPoints.point5' | translate"></span>
    </div>

    <div class="challenge-tutorial__container-section">
      <span [innerHTML]="'CHALLENGE_TUTORIAL.sectionPoints.point6' | translate"></span>
    </div>

    <div class="challenge-tutorial__container-section">{{ 'CHALLENGE_TUTORIAL.sectionPoints.point7' | translate }}</div>
  </app-challenge-expansion-panel>

  <app-challenge-expansion-panel class="challenge-tutorial__container" trigger="all">
    <div expansionHeader class="challenge-tutorial__container-heading">
      {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.heading' | translate }}
    </div>

    <div class="challenge-tutorial__container-section">
      <span [innerHTML]="'CHALLENGE_TUTORIAL.sectionBonusPoints.point1' | translate"></span>
    </div>

    <div class="challenge-tutorial__container-section">
      <p class="challenge-tutorial__container-paragraph-heading challenge-tutorial__container-paragraph--orange">
        {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.freshenUp' | translate }}
        <span class="challenge-tutorial__container-paragraph-heading-points"
          >(20 {{ 'CHALLENGE_TUTORIAL.points' | translate }})</span
        >
      </p>
      <div class="challenge-tutorial__container-indented-container">
        ▪︎
        <p class="challenge-tutorial__container-indented">
          {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.freshenUpDesc' | translate }}
        </p>
      </div>
    </div>

    <div class="challenge-tutorial__container-section">
      <p class="challenge-tutorial__container-paragraph-heading challenge-tutorial__container-paragraph--orange">
        {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.teaTime' | translate }}
        <span class="challenge-tutorial__container-paragraph-heading-points"
          >(20 {{ 'CHALLENGE_TUTORIAL.points' | translate }})</span
        >
      </p>
      <div class="challenge-tutorial__container-indented-container">
        ▪︎
        <p class="challenge-tutorial__container-indented">
          {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.teaTimeDesc' | translate }}
        </p>
      </div>
    </div>

    <div class="challenge-tutorial__container-section">
      <p class="challenge-tutorial__container-paragraph-heading challenge-tutorial__container-paragraph--orange">
        {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.diversity' | translate }}
        <span class="challenge-tutorial__container-paragraph-heading-points"
          >(40 {{ 'CHALLENGE_TUTORIAL.points' | translate }})</span
        >
      </p>
      <div class="challenge-tutorial__container-indented-container">
        ▪︎
        <p class="challenge-tutorial__container-indented">
          {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.diversityDesc' | translate }}
        </p>
      </div>
    </div>

    <div class="challenge-tutorial__container-section">
      <p class="challenge-tutorial__container-paragraph-heading challenge-tutorial__container-paragraph--orange">
        {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.salmagundi' | translate }}
        <span class="challenge-tutorial__container-paragraph-heading-points"
          >(300 {{ 'CHALLENGE_TUTORIAL.points' | translate }})</span
        >
      </p>
      <div class="challenge-tutorial__container-indented-container">
        ▪︎
        <p class="challenge-tutorial__container-indented">
          {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.salmagundiDesc1' | translate }}
        </p>
      </div>
      <div class="challenge-tutorial__container-indented-container">
        ▪︎
        <p class="challenge-tutorial__container-indented">
          {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.salmagundiDesc2' | translate }}
        </p>
      </div>
    </div>

    <div class="challenge-tutorial__container-section">
      <span [innerHTML]="'CHALLENGE_TUTORIAL.sectionBonusPoints.point2' | translate"></span>
    </div>

    <div class="challenge-tutorial__container-section">
      <p class="challenge-tutorial__container-paragraph-heading challenge-tutorial__container-paragraph--orange">
        {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.weeklyWinner' | translate }}
        <span class="challenge-tutorial__container-paragraph-heading-points"
          >(100 {{ 'CHALLENGE_TUTORIAL.points' | translate }})</span
        >
      </p>
      <div class="challenge-tutorial__container-indented-container">
        ▪︎
        <p class="challenge-tutorial__container-indented">
          {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.weeklyWinnerDesc1' | translate }}
        </p>
      </div>
      <div class="challenge-tutorial__container-indented-container">
        ▪︎
        <p class="challenge-tutorial__container-indented">
          {{ 'CHALLENGE_TUTORIAL.sectionBonusPoints.weeklyWinnerDesc2' | translate }}
        </p>
      </div>
    </div>
  </app-challenge-expansion-panel>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/challenge-tutorial/challenge-tutorial.component.html